import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import parallaxHero from '../features/parallax-hero';

register('slideshow', [slider, parallaxHero]);
